<template>
  <div
    ref="gameContainer"
    style="
      max-width: 480px;
      padding: 0;
      max-height: 100vh !important;
      margin: auto;
    "
  ></div>
</template>

<script>
import { mapState } from "vuex";
const extra = require("@/mockups/ABC/extra/main");

export default {
  name: "extra",
  components: {
    //
  },
  computed: mapState({
    //
  }),
  props: [
    //
  ],
  data: () => ({
    //
  }),
  created() {
    //
  },
  mounted() {
    this.initializeGame();
  },
  methods: {
    initializeGame() {
      this.gameInstance = extra.launch(this.$refs.gameContainer);
      this.gameInstance.scene.start("Vocab1Scene", {
        env: this.env,
      });
    },
  },
  beforeDestroy() {
    if (this.gameInstance) {
      this.gameInstance.destroy(true);
    }
  },
};
</script>